import { render, staticRenderFns } from "./search-zhuanbing.vue?vue&type=template&id=38aac2fa&scoped=true&"
import script from "./search-zhuanbing.vue?vue&type=script&lang=ts&"
export * from "./search-zhuanbing.vue?vue&type=script&lang=ts&"
import style0 from "./search-zhuanbing.vue?vue&type=style&index=0&id=38aac2fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aac2fa",
  null
  
)

export default component.exports